import React from "react";
import MainLayout from "../../../Partials/MainLayout";
import FeedLayout from "../../../Partials/FeedLayout";
import MyPosts from "./List";

const Home = () => {
    return (
        <MainLayout>
            <FeedLayout>
                <MyPosts />
            </FeedLayout>
        </MainLayout>
    );
};

export default Home;
